<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <div>
          <a-radio-group v-model="mon" @change="onChangemon">
            <a-radio :disabled="disabledAll" v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
          </a-radio-group>
        </div>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input :disabled="disabledAll" v-model="applicantInfo.name" @change="handleName('name')" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" placeholder="请输入投保企业名称" @blur="queryCompanyCodeByName"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="投保人行业类别">
            <a-cascader :options="industryList" :disabled="disabledAll" :field-names="{ label: 'text' }"
              :show-search="{ filter }" @change="
                (value, label) => handleChange(value, 'industrycode', label)
              " :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" v-decorator="[
                'applicantInfo.industrycode',
                { rules: [{ required: true, message: '请选择' }] },
              ]" placeholder="请选择行业" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }],
                },
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								:disabled="disabledAll"
								v-model="applicantInfo.idNumber"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [{ required: true, message: '请输入投保企业证件号码' }],
									},
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人企业类别">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'occupationcodesh')"
              v-decorator="[
                'applicantInfo.occupationcodesh',
                {
                  rules: [{ required: true, message: '请选择投保人企业类别' }],
                },
              ]"
              placeholder="请选择投保人企业类别"
            >
              <a-select-option v-for="item in companyPropertyList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人注册资本币种">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'vehicletype')"
              v-decorator="[
                'applicantInfo.vehicletype',
                {
                  initialValue: 'CNY',
                  rules: [{ required: true, message: '请选择投保人注册资本币种' }],
                },
              ]"
              placeholder="请选择投保人注册资本币种"
            >
              <a-select-option v-for="item in vehicleOptions" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人公司注册资金">
            <a-input-number
              style="width: 250px"
              :disabled="disabledAll"
              :min="0"
              v-decorator="[
                'applicantInfo.registeredAssets',
                {
                  rules: [{ required: true, message: '请输入投保人公司注册资金' }],
                },
              ]"
              placeholder="请输入投保人公司注册资金"
            ></a-input-number>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="18">
          <a-form-item :label-col="{ span: 4 }" label="被保人名称">
            <a-input :disabled="disabledAll" v-model="applicantInfo.projectname" @change="handleName('projectname')" v-decorator="['applicantInfo.projectname', { rules: [{ required: true, message: '请输入被保人名称' }] }]" placeholder="请输入被保人名称" @blur="queryCompanyCodeByName"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-checkbox
            :disabled="disabledAll"
            @change="onChangeConSfid"
            v-decorator="['sameCheck']"
          >
            同投保人
          </a-checkbox>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="被保人行业类别">
            <a-cascader :options="industryList" :disabled="disabledAll" :field-names="{ label: 'text' }"
              :show-search="{ filter }" @change="
                (value, label) => handleChange(value, 'enttypecode', label)
              " :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }" v-decorator="[
                'applicantInfo.enttypecode',
                { rules: [{ required: true, message: '请选择' }] },
              ]" placeholder="请选择行业" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" type="flex">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'projectamount')"
              v-decorator="[
                'applicantInfo.projectamount',
                {
                  rules: [{ required: true, message: '请选择被保人证件类型' }],
                },
              ]"
              placeholder="请选择被保人证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" flex="1 50px">
          <a-form-item :label-col="{ span: 6 }" label="被保人证件号码">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.projectarea"
              v-decorator="[
                'applicantInfo.projectarea',
                {
                  rules: [{ required: true, message: '请输入被保人证件号码' }],
                },
              ]"
              placeholder="请输入被保人证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人企业类别">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'schooltype')"
              v-decorator="[
                'applicantInfo.schooltype',
                {
                  rules: [{ required: true, message: '请选择被保人企业类别' }],
                },
              ]"
              placeholder="请选择被保人企业类别"
            >
              <a-select-option v-for="item in companyPropertyList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader
              :disabled="disabledAll"
              placeholder="请选择"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
              style="float: left; width: 250px"
            />
          </a-col>
          <a-col :span="12">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.detailaddress"
              v-decorator="[
                'applicantInfo.detailaddress',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]"
              placeholder="请输入联系地址"
              style="float: left; width: 350px; margin-left: 10px"
            ></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人姓名">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsname"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入企业联系人姓名' }],
                },
              ]"
              placeholder="请输入企业联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人电话">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.telephone"
              v-decorator="[
                'applicantInfo.telephone',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' },
                  ],
                },
              ]"
              placeholder="请输入企业联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人邮箱">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.email"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' },
                  ],
                },
              ]"
              placeholder="请输入企业联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'payMethod')"
              style="width: 133px"
              placeholder="请选择支付方式"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付方式' }],
                },
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredList :architecture="RiskInfos.salPolicyExt.architecture.toString()" :effectiveDate="applicantInfo.effectiveDate" :disabledAll="disabledAll" :columns="columns" :data="data" @delSelect="delSelectpre" @addSelect="addSelectpre" @EduitSelect="EduitSelect"></salInsuredList>

      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="发票类型">
            <a-select placeholder="请选择" @change="invoiceprinttypeChange" v-model="applicantInfo.invoiceprinttype">
              <a-select-option value="01">暂不开票</a-select-option>
              <a-select-option value="03">电子发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="applicantInfo.invoiceprinttype == '03'">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input v-model="applicantInfo.taxpayercertificateno" v-decorator="['applicantInfo.taxpayercertificateno', { rules: [{ required: true, message: '请输入纳税人识别号' }] }]" placeholder="请输入纳税人识别号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
        </a-form-item>
      </a-row>

      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px"> 投保人已充分阅读、理解并同意<fileView></fileView> </a-checkbox>
      </a-row>
      <a-row class="order">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">编辑</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p style="text-align: center; font-size: 18px; margin-bottom: 0; padding: 20px; line-height: 30px">
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold"> {{ applicantInfo.totalPremium }} </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import moment from 'moment';
import salInsuredList from './salInsuredList';
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
import Dict from '../data/index'
import { industryList } from '../data/industryCode'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    salInsuredList,
  },
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      industryList,
      disabledAll: false,
      leibie: '1类', //产品类别
      yueduBtn: false, //阅读中
      saveBtnShow: false, //保存过
      submitLoad1: false, //保存中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        projectname: "", // 被保人名称
        projectamount: "", // 被保人证件类型，同投保人证件类型
        projectarea: "", // 被保人证件号码
        pacCode: '', //省市区
        detailaddress: '', //详细地址
        contactsname: '', //联系人名称
        telephone: '', //联系人电话
        email: '', // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: '', //备注
        invoiceprinttype: '01', //发票类型
        taxpayercertificateno: '', //纳税人识别号
        payMethod: '', //支付方式
        totalPremium: 0, //总保费
        juvenilesAvgpremuim: 0, //单个保费
        expireDate: '',
        effectiveDate: '', //投保期限
        payUrl: '', // 支付链接
      },
      sameCheck: false, // 同投保人
      address: '',
      //表格的头部
      columns: Dict.columns,
      //表格的数据
      data: [],
      rate: 0.2, //费率
      maxType: 1, //最大类别
      companyCode: '01', //企业性质
      perRiskInfo: '', //险种类
      evidenceNumber: '', //凭证号
      riskNumber: {}, //计算保费
      uniqueArr: [], //去重后的人数列表
      //投保人证件类型
      companyIdTypeOptions: Dict.companyIdTypeOptions,
      //投保的天数
      guarantPre: Dict.guarantPre,
      companyPropertyList: Dict.companyPropertyList, // 企业类别
      vehicleOptions: Dict.vehicleOptions, // 注册币种
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      RiskInfos: {
        architecture: '0',
        salPolicyExt: {
          architecture: 0,
        },
        salPolicy: {
          productCode: '', //产品code
          bracket: 3, //保费期限
          planCode: '',
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          planinfos: '', //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [], //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      CScontent: {},
      ContentView: {}, //展示的保费
      copyCScontent: {}, //拷贝的
      creator: '1',
      productCode: '',
      // plan: '',
      userParams: '',
      /**需要的数据结束 */
      mon: 'MONTH_1',
      baodanData: {
        startdata: '',
      },
      linshiContent: {},
      // riskInfosAmount:{},//计算险种的结果
      typeNumObj: {
        '1类': 0,
        '2类': 0,
        '3类': 0,
        '4类': 0,
        '5类': 0,
      },
      orderContent: {},
      xianzhiHYcode: [], //限制的行业code
      riskInfos: [], // 险种信息
      gztypestr: '',
      occulevelPriceMap: '',
      planinfos: ''
    };
  },
  //监听属性 类似于data概念
  computed: {
    addressOptions() {
      let addr = this.$lodash.cloneDeep(window.addrescode);
      let dataArr = this.disabledCity(addr);
      return dataArr;
    },
    applicantInfoExpireDate() {
      let mon = this.mon.split('_')[0];
      let num = Number(this.mon.split('_')[1] || 1);
      let date = this.applicantInfo.effectiveDate;
      let t2;
      if (date && mon) {
        if(mon === 'MONTH') {
          t2 = moment(date).add(num, 'months').subtract(1, 's');
        } else {
          t2 = moment(date).add(1, 'year').subtract(1, 's');
        }
      }
      return t2;
    },
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[2].value || null);
    },
  },
  //方法集合
  methods: {
    moment,
    // 禁选城市
    disabledCity(dataArr) {
      // 不承保注册地或营业地在天津市及所辖地区的企业;
      // 北京-平谷/密云；
      // 河北-邢台/廊坊/秦皇岛青龙县/沧州/三河
      // 河南-信阳
      // 山东-招远/禹城/荣成/德州/临沂/莱阳
      // 黑龙江-齐齐哈尔
      // 吉林-四平
      // 辽宁-铁岭
      // 湖北-黄冈/麻城
      // 江苏-常州/连云港市
      const disabledCodeArr = ['120000', '110117', '110118', '130500', '131000', '130321', '130900', '131082', '411500', '370685', '371482', '371082', '371400', '371300', '370682', '230200', '220300', '211200', '421100', '421181', '320400', '320700'];
      let options = dataArr.map(item => {
        if(disabledCodeArr.indexOf(item.value) > -1) {
          item.disabled = true;
        }else if(item.children && item.children.length > 0) {
          this.disabledCity(item.children);
        }
        return item;
      })
      return options;
    },
    productName() {
      return sessionStorage.getItem('productName')
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    gonOne() {
      this.disabledAll = false;
      this.copyCScontent[this.leibie] = this.applicantInfo.juvenilesAvgpremuim;
      this.$bus.$emit('disabledBus', false);
      this.$router.push({
        name: 'tkgbgz',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          // planCode: this.$route.query.planCode,
        },
      });
    },
    handleName() {
      if (this.data.length) {
        this.resultPremiumSum(this.RiskInfos);
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0] && oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0] && twoArr[0].children.filter(item => item[str] == arr[2]) || [];
          sessionStorage.setItem('pacCode', threeArr[0]);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]],
        };
      }
    },
    //打开文件列表
    fileListClick() {
      this.$store.commit('setNotShow', true);
    },
    //判断是否有多种类别
    checkBaseList(list) {
      return list.filter(e => e.personNum > 0).length > 0;
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId,
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            //
            this.orderContent = res.data.content;
            this.$bus.$emit('busRiskInfos', this.orderContent);
            this.$store.commit('setOrderContent', this.orderContent);
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.data = res.data.content.salInsuredList;
              this.data.forEach((element, i) => {
                let str = element.birthDate;
                element.occupation = [element.occupationCode.substring(0, 3), element.occupationCode.substring(0, 5), element.occupationCode]; //职业类别代码
                element['index'] = i + 1;
                // element.birthDate = str.replace(/\//g, "-"); //生日
                element['relationship'] = 9;
                element.birthDate = str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6, 8); //生日
              });
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.policyId = salPolicy.id.toString();
              this.plan = salPolicy.planCode;
              this.applicantInfo.totalPremium = salPolicy.totalPremium;
              this.applicantInfo.juvenilesAvgpremuim = salPolicy.juvenilesAvgpremuim;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.$store.commit('setproductCode', this.productCode);
              let effectiveDate;
              if (this.$route.query.xb) {
                //续保情况下时间处理
                effectiveDate = moment(salPolicy.expireDate).add(1, 'days');
              } else {
                effectiveDate = moment(salPolicy.effectiveDate);
              }
              this.applicantInfo.effectiveDate = moment(effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(effectiveDate).format('YYYY-MM-DD'),
                },
                baodanData: {
                  startdata: moment(effectiveDate).format('YYYY-MM-DD'),
                },
              });
            }

            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              let planArr = salPolicyHolder.planinfos.split(',')
              if(planArr[3] === 'YEAR') {
                this.mon = 'YEAR_12'
              } else {
                this.mon = `${planArr[3]}_${planArr[4]||1}`
              }
              this.applicantInfo.name = res.data.content.salPolicyHolder.name;
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).arrCode;
              this.address = salPolicyHolder.address;
              let industrycode = salPolicyHolder.industrycode || ''
              let enttypecode = salPolicyHolder.enttypecode || ''
              this.applicantInfo.industrycode = industrycode.split(',');
              this.applicantInfo.enttypecode = enttypecode.split(',');


              sessionStorage.setItem('pacCode', salPolicyHolder.district);
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).code,
                  industrycode: industrycode.split(','),
                  enttypecode: enttypecode.split(',')
                },
                sameCheck: salPolicyHolder.idNumber === salPolicyHolder.projectarea
              });
            }

            this.data = res.data.content.salInsuredList;
            this.riskNumber = this.countTimes(this.data);
            this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = { ...this.RiskInfos.salPolicy, ...res.data.content.salPolicy };
            this.RiskInfos.salPolicyHolder = { ...this.RiskInfos.salPolicyHolder, ...res.data.content.salPolicyHolder };
            this.RiskInfos.salPolicyHolder.addfifty = '2';
            this.RiskInfos.architecture = this.orderContent.architecture ? this.orderContent.architecture.toString() : '0';
            this.resultPremiumSum(this.RiskInfos, 'eduit');
          }
        }
      });
    },
    //反转对象
    resoverObj(obj) {
      var a = {
        '1类': 0,
        '2类': 0,
        '3类': 0,
        '4类': 0,
        '5类': 0,
      };
      for (const key in obj) {
        a[key] = obj[key];
      }
      return a;
    },
    //统计次数
    numResult(data) {
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0,
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }

      return d;
    },
    //处理证件类型
    getterIdtype(value) {
      switch (value) {
        case '身份证':
        case '01':
        case 1:
        case '1':
          return '身份证';
        case '护照':
        case '02':
        case '2':
        case 0:
          return '护照';
        case "其它":
        case "99":
        case 99:
          return "其它";
        default:
          return '身份证';
      }
    },
    //处理性别
    getterGender(value) {
      switch (value) {
        case 'M':
        case '男':
          return '男';
        case 'F':
        case '女':
          return '女';
        default:
          return '男';
      }
    },
    getterData(data) {

      let gerdata = [];
      data.forEach(e => {
        let strArr = [e.name, this.getterIdtype(e.idType), e.idNumber, e.birthDate, this.getterGender(e.gender), e.occupationCode, '', '', e.occupationName, '', 1, '', e.occulevel.toString().slice(0, 1)];
        gerdata.push(strArr.join(','));
      });

      return gerdata.join(';');
    },
    filter(inputValue, path) {
      return path.some(option => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //试算的接口
    resultPremiumSum(data, type) {

      let copyData = this.$lodash.cloneDeep(data);

      let guapre = this.mon.split('_')
      let planinfos = `1,N,N,${guapre[0]}, ${guapre[1]}`
      if(copyData.salPolicyHolder.planinfos) {
        let arr = copyData.salPolicyHolder.planinfos.split(',')
        arr.splice(3, 2, guapre[0], guapre[1])
        planinfos = arr.join(',')
      }
      this.planinfos = planinfos
      let formData = {
        salPolicy: {
          planCode: this.productCode, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          planinfos,
        },
        salInsuredList: this.data.map(item => {
          return {
            occulevel: item.occulevel.split('')[0]
          }
        }), //人数
      };

      this.$api.calPremiumEmployer(formData).then(res => {
        if (res.data.success) {
          let datas = res.data.content;
          this.CScontent = datas;
          this.perRiskInfo = this.$lodash.cloneDeep(datas.perRiskInfo);
          delete datas['perRiskInfo'];
          this.ContentView = this.$lodash.cloneDeep(datas); //恒定不变的展示用，做限制
          this.copyCScontent = this.resoverObj(this.$lodash.cloneDeep(datas)); //计算用的改变的数据
          this.riskInfos = datas.riskInfos
          this.gztypestr = datas.gztypestr
          this.occulevelPriceMap = datas.occulevelPriceMap
          if (type != 'eduit') {
            this.applicantInfo.totalPremium = datas.totalPremium;
          }
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },
    //选择天数的
    onChangemon(e) {
      this.mon = e.target.value;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + '-' + m + '-' + d;
      var currents = moment(time);
      return current && current < currents;
    },
    //修改
    EduitSelect(data) {

      this.data.forEach((e, i) => {
        if (i == data.eduitIndex) {
          this.data[i] = data;
        }
        if (e.occulevel.toString().indexOf('类') <= -1) {
          e.occulevel = e.occulevel + '类';
        }
      });
      this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
      this.riskNumber = this.countTimes(this.data);

      this.resultPremiumSum(this.RiskInfos);

    },
    //粘贴
    addSelectpre(data) {
      if (Array.isArray(data)) {
        this.data.push(...data);
      } else {
        this.data.push(data);
      }
      let cesiData = this.$lodash.cloneDeep(this.data);
      this.data = this.unique(this.data, 'idNumber');
      if (cesiData.length != this.data.length) {
        this.$message.warning('受保人有重复，已做删除');
      }

      this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
      this.riskNumber = this.countTimes(this.data);

      this.resultPremiumSum(this.RiskInfos);
    },
    //批量删除
    delSelectpre(data) {
      this.data = data;
      let cesiData = this.$lodash.cloneDeep(this.data);
      this.data = this.unique(this.data, 'idNumber');
      if (cesiData.length != this.data.length) {
        this.$message.warning('受保人有重复，已做删除');
      }

      this.RiskInfos.premiumBaseDtoList = this.numResult(this.data);
      this.riskNumber = this.countTimes(this.data);

      if (this.data.length) {
        this.resultPremiumSum(this.RiskInfos);
      } else {
        this.applicantInfo.totalPremium = 0;
      }
    },
    //提交的去重
    unique(arr, attribute) {
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
    filterSalInsuredList(data) {
      return data.filter(e => {
        switch (e['gender']) {
          case '男':
          case 'M':
            e['gender'] = 'M';
            break;
          case '女':
          case 'F':
            e['gender'] = 'F';
            break;
        }
        e['relationship'] = 9;
        e['occulevel'] = e.occulevel.toString().split('')[0];
        e["premium"] = this.occulevelPriceMap[e.occulevel];
        return e.occulevel;
      });
    },
    //计算总保费
    countTimes(data) {
      var a = [];
      if (data.length) {
        data.forEach(e => {
          let leve = e.occulevel.toString().indexOf('类') > -1 ? e.occulevel.toString() : e.occulevel.toString() + '类';
          a.push(leve);
        });
        return a.reduce(function (time, name) {
          if (name in time) {
            time[name]++;
          } else {
            time[name] = 1;
          }
          return time;
        }, {});
      } else {
        return {
          '1类': 0,
          '2类': 0,
          '3类': 0,
          '4类': 0,
          '5类': 0,
        };
      }
    },
    //计算总保费
    sumZfeiyong(content, riskNumber) {


      var jichu = {
        '1类': 0,
        '2类': 0,
        '3类': 0,
        '4类': 0,
        '5类': 0,
      };
      for (const key in content) {
        jichu[key] = this.$accuracy.mul(Number(content[key]), Number(riskNumber[key] || 0));
      }

      return jichu;
    },
    //最后的提交
    handleSubmit() {

      // e && e.preventDefault();
      let ageStatus = true;
      this.data.forEach(e => {
        let age = this.$tools.jsGetAge(e.birthDate, moment(this.applicantInfo.effectiveDate).format('YYYY-MM-DD'));
        if (age < 16 || age > 60) {
          this.$message.error('投保人年龄仅限于16-60周岁，请修改后再试！');
          ageStatus = false;
          return;
        }
      });
      if (!ageStatus) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {

          let base = this.applicantInfo;
          let data = {
            salInsuredList: this.filterSalInsuredList(this.data), //表格的数据
            salPolicy: {
              //保单信息
              planCode: this.productCode, //产品计划 （固定值ConstructAccident）
              productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
              creator: this.creator,
              id: this.policyId,
              // issueDate: moment().format("YYYY-MM-DD HH:mm:ss"), //applyTime  投保时间（当前时间）
              effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
              expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
              payMethod: values.applicantInfo.payMethod, //支付方式”
              totalPremium: base.totalPremium, //totalPremium  总保费
              remark: values.applicantInfo.remark, //备注
            },
            salPolicyExt: {
              occEmpVersion: this.fileCodeContent.id
            },
            salPolicyHolder: {
              //投保人信息
              type: 'C', //固定值
              name: values.applicantInfo.name, //name  投保人名称
              idType: values.applicantInfo.idType, //证件类型
              idNumber: values.applicantInfo.idNumber, //certNo   证件号码
              occupationcodesh: values.applicantInfo.occupationcodesh, // 投保人企业类别 （1）全民所有制企业——码值为1；（2）集体所有制企业——码值为2；（3）联营企业——码值为3；（4）在中华人民共和国境内设立的中外合资经营企业、中外合作经营企业和外资企业——码值为4；（5）私营企业——码值为5；（6）依法需要办理企业法人登记的其他企业——码值为6
              vehicletype: values.applicantInfo.vehicletype,  // 投保人注册资本币种 CNY-人民币元、USD-美元、EUR-欧元、JPY-日元、GBP-英镑、AUD-澳大利亚元、CHF-瑞士法郎、CAD-加元、KRW-韩元，默认选择CNY-人民币元
              registeredAssets: values.applicantInfo.registeredAssets,  // 投保人公司注册资金
              industrycode: values.applicantInfo.industrycode.join(','),  // 投保人行业类别
              contactsname: values.applicantInfo.contactsname, //联系人姓名
              telephone: values.applicantInfo.telephone, //联系人电话
              email: values.applicantInfo.email, //联系人邮箱

              projectname: values.applicantInfo.projectname, // 被保人名称
              projectamount: values.applicantInfo.projectamount, // 被保人证件类型，同投保人证件类型
              projectarea: values.applicantInfo.projectarea, // 被保人证件号码
              schooltype: values.applicantInfo.schooltype, // 被保人企业类别 （1）全民所有制企业——码值为1；（2）集体所有制企业——码值为2；（3）联营企业——码值为3；（4）在中华人民共和国境内设立的中外合资经营企业、中外合作经营企业和外资企业——码值为4；（5）私营企业——码值为5；（6）依法需要办理企业法人登记的其他企业——码值为6
              enttypecode: values.applicantInfo.enttypecode.join(','),  // 被保人行业类别

              address: `${base.pacCode[0].text},${base.pacCode[1].text},${base.pacCode[2].text}`, //地址
              province: base.pacCode[0].text, //省
              city: base.pacCode[1].text, //市
              district: base.pacCode[2].text, //区
              addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
              detailaddress: values.applicantInfo.detailaddress, //详细地址
              planinfos: this.planinfos,
              gztypestr: this.gztypestr,
            },
            riskInfos: this.riskInfos
          };


          this.postPolicyData = data;
          // return
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.submitLoad1 = true;
          this.axiosPolicy(); // 保存订单是 直接保存
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    axiosPolicy() {
      //提交保单
      this.$api
        .employerPolicy(this.postPolicyData)
        .then(res => {
          if (res.data.returnCode == '00') {
            this.showPaySure = false;
            this.saveBtnShow = true;
            this.policyId = res.data.content;
            this.$message.success('保存成功！');
            this.$router.push({
              name: 'tkgbgz',
              query: {
                u: this.$route.query.u,
                p: this.$route.query.p,
                sign: this.$route.query.sign,
                policyId: this.policyId,
                // planCode: this.$route.query.planCode,
                continuation: '1'
              },
            });
            this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
          }
        })
        .finally(() => {
          this.submitLoad1 = false;
        });
    },
    //立即投保
    fastInsure() {
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      this.$store.commit('setLoading', {
        show: true,
        text: '核保中，请稍后...'
      });
      this.$api
        .payBeforeUnderwriting(this.$route.query.policyId)
        .then(res => {
          if (res.data.returnCode != '00') {
            this.$notification.error({
              duration: null,
              message: '提示',
              description: res.data.returnMsg
            });
            this.payUrl = '';
            return;
          }
        //   const content = JSON.parse(res.data.content);
          // 支付二维码链接
          this.payUrl = res.data.content && res.data.content.payUrl;
          this.showPaySure = true;
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;

      this.$payModal({
        show: true,
        type: 'tkgbgz', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name,
        payUrl: this.payUrl, // 支付链接
        noInsured: true // 不需要调最后的publicpayApi接口
      });
    },
    handleChange(value, type, label) {

      this.xianzhiHYcode = value;
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.address = label.length > 2 ? label[0].text + label[1].text + label[2].text : '';
        sessionStorage.setItem('pacCode', value[2]);
      } else {
        this.applicantInfo[type] = value;
      }
      if(type == 'idType') {
        this.queryCompanyCodeByName()
      }
    },
    queryCompanyCodeByName() {
      if(!this.applicantInfo.idType) {
        return
      }
      this.queryCompanyIdNumber(this.applicantInfo.name, this.applicantInfo.idType, this.companyIdTypeOptions);
    },
    // 修改是否同投保人
    onChangeConSfid(val) {
      this.sameCheck = val
      const checked = val.target.checked
      if(checked) {
        const values = this.form.getFieldsValue()
        this.form.setFieldsValue({
          applicantInfo: {
            projectname: values.applicantInfo.name, // 被保人名称
            projectamount: values.applicantInfo.idType, // 被保人证件类型，同投保人证件类型
            projectarea: values.applicantInfo.idNumber, // 被保人证件号码
            schooltype: values.applicantInfo.occupationcodesh, // 被保人企业类别 （1）全民所有制企业——码值为1；（2）集体所有制企业——码值为2；（3）联营企业——码值为3；（4）在中华人民共和国境内设立的中外合资经营企业、中外合作经营企业和外资企业——码值为4；（5）私营企业——码值为5；（6）依法需要办理企业法人登记的其他企业——码值为6
            enttypecode: values.applicantInfo.industrycode,  // 被保人行业类别
          }
        })
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const { p, u } = this.$route.query;
    this.productCode = p
    // this.plan = planCode
    this.creator = u
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$bus.$on('onRiskInfos', data => {
      let strdata = this.$lodash.cloneDeep(data);
      this.RiskInfos.architecture = strdata.architecture;
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      let planArr = strdata.salPolicyHolder.planinfos.split(',')
      if(planArr[3] === 'YEAR') {
        this.mon = 'YEAR_12'
      } else {
        this.mon = `${planArr[3]}_${planArr[4]||1}`
      }

      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('CScontent');
    // this.$bus.$off("clearData");
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.insure-check {
  display: flex;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}
</style>